import {isMobile} from "../utils/utils";

export default class Help {
    static preload(scene){
        scene.load.image('wasd', 'src/assets/img/wasd.png');
    }

    constructor({scene}){
        this.scene = scene;
        this.hidden = false;
        if(!isMobile()){
            this.help = scene.add.image(scene.game.config.width / 2, scene.game.config.height - 200, 'wasd');
            this.help.setScale(0.75);
            this.help.alpha = 0.7;
        }
    }

    update(timePassed){
        if(!this.hidden && timePassed > 5) {
            this.hide();
        }
    }

    hide(){
        this.hidden = true;
        this.scene.tweens.add({
            targets: [this.help],
            alpha: 0,
            duration: 200,
            ease: Phaser.Math.Easing.Sine.Out,
        })
    }
}